import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import AppLayout from '../components/feature/AppLayout';

const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const FunnelAnalysisPage = lazy(() => import('../pages/funnel-analysis/page'));
const TrafficSourcesPage = lazy(() => import('../pages/traffic-sources/page'));
const DailyPerformancePage = lazy(() => import('../pages/daily-performance/page'));
const SessionJourneyPage = lazy(() => import('../pages/session-journey/page'));
const ConversionInsightsPage = lazy(() => import('../pages/conversion-insights/page'));
const LeadsPage = lazy(() => import('../pages/leads/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const Fallback = () => (
  <div className="flex items-center justify-center h-screen bg-black">
    <div className="flex flex-col items-center gap-3">
      <div className="w-8 h-8 border-2 border-amber-500/30 border-t-amber-400 rounded-full animate-spin" />
      <p className="text-zinc-500 text-sm">Yükleniyor...</p>
    </div>
  </div>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <AppLayout />,
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Fallback />}>
            <DashboardPage />
          </Suspense>
        ),
      },
      {
        path: 'funnel-analysis',
        element: (
          <Suspense fallback={<Fallback />}>
            <FunnelAnalysisPage />
          </Suspense>
        ),
      },
      {
        path: 'traffic-sources',
        element: (
          <Suspense fallback={<Fallback />}>
            <TrafficSourcesPage />
          </Suspense>
        ),
      },
      {
        path: 'daily-performance',
        element: (
          <Suspense fallback={<Fallback />}>
            <DailyPerformancePage />
          </Suspense>
        ),
      },
      {
        path: 'session-journey',
        element: (
          <Suspense fallback={<Fallback />}>
            <SessionJourneyPage />
          </Suspense>
        ),
      },
      {
        path: 'conversion-insights',
        element: (
          <Suspense fallback={<Fallback />}>
            <ConversionInsightsPage />
          </Suspense>
        ),
      },
      {
        path: 'leads',
        element: (
          <Suspense fallback={<Fallback />}>
            <LeadsPage />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '*',
    element: (
      <Suspense fallback={<Fallback />}>
        <NotFound />
      </Suspense>
    ),
  },
];

export default routes;